import React, { PureComponent } from 'react';

import type { CustomGlyphProps, GlyphProps } from '@atlaskit/icon/types';
import Icon from '@atlaskit/icon';

const AtlassianIntelligenceGlyph = (props: CustomGlyphProps) => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		data-testid={props['data-testid']}
		aria-label={props['aria-label']}
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
		className={props.className}
	>
		<path
			d="M18.1399 11.0098C17.5876 11.0098 17.1399 11.4575 17.1399 12.0098C17.1399 12.5621 17.5876 13.0098 18.1399 13.0098H19.9999C20.5522 13.0098 20.9999 12.5621 20.9999 12.0098C20.9999 11.4575 20.5522 11.0098 19.9999 11.0098H18.1399Z"
			fill="currentColor"
		/>
		<path
			d="M15.6701 14.2558C15.2796 13.8653 14.6465 13.8653 14.2559 14.2558C13.8654 14.6463 13.8654 15.2795 14.2559 15.67L19.2905 20.7046C19.6811 21.0951 20.3142 21.0951 20.7047 20.7046C21.0953 20.3141 21.0953 19.6809 20.7047 19.2904L15.6701 14.2558Z"
			fill="currentColor"
		/>
		<path
			d="M11 5.86035C11 6.41264 11.4477 6.86035 12 6.86035C12.5523 6.86035 13 6.41264 13 5.86035V4.00035C13 3.44807 12.5523 3.00035 12 3.00035C11.4477 3.00035 11 3.44807 11 4.00035V5.86035Z"
			fill="currentColor"
		/>
		<path
			d="M14.2558 8.32985C13.8653 8.72038 13.8653 9.35354 14.2558 9.74407C14.6463 10.1346 15.2795 10.1346 15.67 9.74407L20.7046 4.70946C21.0951 4.31894 21.0951 3.68578 20.7046 3.29525C20.3141 2.90473 19.6809 2.90473 19.2904 3.29525L14.2558 8.32985Z"
			fill="currentColor"
		/>
		<path
			d="M5.86011 12.9902C6.41239 12.9902 6.86011 12.5425 6.86011 11.9902C6.86011 11.4379 6.41239 10.9902 5.86011 10.9902H4.00011C3.44782 10.9902 3.00011 11.4379 3.00011 11.9902C3.00011 12.5425 3.44782 12.9902 4.00011 12.9902H5.86011Z"
			fill="currentColor"
		/>
		<path
			d="M8.32961 9.74422C8.72013 10.1347 9.3533 10.1347 9.74382 9.74422C10.1343 9.35369 10.1343 8.72053 9.74382 8.33L4.70922 3.2954C4.3187 2.90488 3.68553 2.90488 3.29501 3.2954C2.90448 3.68593 2.90448 4.31909 3.29501 4.70962L8.32961 9.74422Z"
			fill="currentColor"
		/>
		<path
			d="M12.99 18.1396C12.99 17.5874 12.5423 17.1396 11.99 17.1396C11.4377 17.1396 10.99 17.5874 10.99 18.1396V19.9996C10.99 20.5519 11.4377 20.9996 11.99 20.9996C12.5423 20.9996 12.99 20.5519 12.99 19.9996V18.1396Z"
			fill="currentColor"
		/>
		<path
			d="M9.74446 15.6701C10.135 15.2796 10.135 14.6465 9.74446 14.2559C9.35394 13.8654 8.72077 13.8654 8.33025 14.2559L3.29565 19.2905C2.90512 19.6811 2.90512 20.3142 3.29565 20.7047C3.68617 21.0953 4.31933 21.0953 4.70986 20.7047L9.74446 15.6701Z"
			fill="currentColor"
		/>
	</svg>
);

export class AtlassianIntelligenceIcon extends PureComponent<GlyphProps> {
	render() {
		return <Icon {...this.props} glyph={AtlassianIntelligenceGlyph} />;
	}
}
